import useTemplateFindById from '@opsbase/react-gql-hooks/template/useTemplateFindById';
import i18n from '@opsbase/lib-i18n';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import React from 'react';
import TemplateEditFormTab from '../../../adminbase/dialogs/templates/TemplateEditFormTab';
export function OpTemplateViewDialog(props) {
    const { id, onClose } = props;
    const { loading, data } = useTemplateFindById({ variables: { id } });
    if (loading || !data) {
        return null;
    }
    return (React.createElement(Dialog, { size: DialogSize.XFULL_YFULL, padded: false, open: true, onClose: onClose, title: data ? data.title : i18n.t('loading') },
        React.createElement(TemplateEditFormTab, { template: data, mode: 'view' })));
}
export default OpTemplateViewDialog;
